import { Box, BoxProps } from '@mui/material';
import jsonExport from 'jsonexport/dist';
import { Fragment, memo } from 'react';
import { BulkDeleteButton, BulkDeleteButtonProps, BulkExportButton, BulkExportButtonProps, Datagrid, DateField, downloadCSV, List, NumberField, ShowButton, ShowView, SimpleShowLayout, TextField, TextInput } from 'react-admin';
import PrefixedImageField from '../../Components/PrefixedImageField';

const BusinessRulesListActionToolbar = (props: BoxProps) => <Box sx={{ alignItems: 'center', display: 'flex' }}>{props.children}</Box>;
const BusinessRulesListBulkActions = memo((props: BulkDeleteButtonProps & BulkExportButtonProps) => (
  <Fragment>
    <BulkDeleteButton {...props} />
    <BulkExportButton {...props} />
  </Fragment>
));
const exporter = (companies: any[]) => {
  //   const data = companies.map((company) => ({
  //     ...company,
  //     backlinks: lodashGet(company, 'backlinks', []).map((backlink: unknown) => backlink.url)
  //   }));
  return jsonExport(companies, (err: Error, csv: string) => downloadCSV(csv, 'companies'));
};

// const QuickFilter = ({ label: string, source: unknown, defaultValue: unknown }) => {
//   const translate = useTranslate();
//   return <Chip sx={{ marginBottom: 1 }} label={translate(label)} />;
// };
//const companiesFilter = [<SearchInput source="q" alwaysOn />, <TextInput source="name" defaultValue="" />, <QuickFilter label="resources.companies.fields.active" source="active" defaultValue />];
const rowClick = (id: unknown, resource: unknown, record: any) => {
  if (record.commentable) {
    return 'edit';
  }
  return 'show';
};
const BusinessRulesPanel = () => {
  return (
    <ShowView>
      <SimpleShowLayout>
        <TextField source="id" />
        <TextField source="name" cellClassName="name" />
        <DateField source="createdAt" sortByOrder="DESC" cellClassName="createdAt" />
        <DateField source="updatedAt" sortByOrder="DESC" cellClassName="updatedAt" />
        <PrefixedImageField source="logoId" cellClassName="logoId" prefix={'https://res.cloudinary.com/dyz7kja60'} />
      </SimpleShowLayout>
    </ShowView>
  );
};

const companiesFilter = [<TextInput label="Company Name" source="name" alwaysOn />, <TextInput source="id" defaultValue="" alwaysOn />, <TextInput source="uuid" defaultValue="" alwaysOn />];

const BusinessRulesList: React.FC = () => {
  return (
    <List filters={companiesFilter} sort={{ field: 'id', order: 'DESC' }} exporter={exporter}>
      <Datagrid bulkActionButtons={<BusinessRulesListBulkActions />} rowClick={rowClick} expand={BusinessRulesPanel} optimized sx={{ image: { maxHeight: '1rem' } }}>
        <TextField source="id" />
        <NumberField source="businessRuleTypeId" />
        <TextField source="rulableType" />
        <NumberField source="rulableId" />
        <TextField source="value" />
        <DateField source="createdAt" />
        <DateField source="updatedAt" />
        <BusinessRulesListActionToolbar>
          <ShowButton />
        </BusinessRulesListActionToolbar>
      </Datagrid>
    </List>
  );
};

export default BusinessRulesList;
